import React from 'react';

export default () => (
  <svg width="14" height="12" viewBox="-1 -1 16 14" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g fill="#16B86F">
        <g>
          <path d="M13.92 2.768a.866.866 0 0 0-.25-.607L12.455.946a.866.866 0 0 0-1.214 0L5.384 6.812 2.759 4.18a.866.866 0 0 0-1.214 0L.33 5.393a.866.866 0 0 0 0 1.214L3.563 9.84l1.214 1.215a.866.866 0 0 0 1.214 0l1.214-1.215 6.465-6.464c.16-.16.25-.384.25-.607z" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/checkmark.es6.js